import React, { Component, Fragment } from 'react';
import { matchPath } from 'react-router';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { Icon } from 'components';
import swal from 'sweetalert';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as AttendancesActions, Selectors as AttendancesSelectors } from 'store/ducks/attendances';
import { Creators as EventsActions, Selectors as EventSelectors } from 'store/ducks/events';

import { Page, Panel, Pagination, Breadcrumbs, Loading, Form } from 'components';
import { Filters } from './components';

class Attendance extends Component {
  state = {
    data: this.props.data,
    filters: {
      cpf: '',
      status: { value: '', label: 'todos' },
      per: { value: 25, label: '25' },
    },
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Lista de Eventos', to: '/events' },
      { name: 'Evento', to: '/events/create' },
      { name: 'Lista de Convidados', to: '' },
    ],
  };

  componentDidMount() {
    const { location, getAttendancesRequest, getAttendancesDashboardRequest, getEventRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getEventRequest(this.handleGetID());
    getAttendancesRequest(this.handleGetID(), page);
    getAttendancesDashboardRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { location, getAttendancesRequest } = this.props;
    const { filters } = this.state;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getAttendancesRequest(this.handleGetID(), queryString.parse(location.search).page, filters);
    }
  }

  handleGetID = () => {
    const { location } = this.props;

    const match = matchPath(location.pathname, { path: '/events/:id/attendances' });
    const { id } = match.params;

    return id;
  };

  handleChangeFilter = async (name, value) => {
    const { filters } = this.state;
    const { location, getAttendancesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    await this.setState({ filters: { ...filters, [name]: value } });
    getAttendancesRequest(this.handleGetID(), page, this.state.filters);
  };

  handleSelectAttendances = () => {
    const { selectAttendancesRequest } = this.props;

    selectAttendancesRequest();
  };

  handleSelectAttendance = id => {
    const { selectAttendanceRequest } = this.props;

    selectAttendanceRequest(id);
  };

  handleAskAttendance = async (e, attendance) => {
    e.preventDefault();

    const action = await swal({
      title: 'Ação',
      text: attendance.attributes.name,
      buttons: {
        cancel: 'Cancelar',
        absent: {
          text: 'Ausente',
          value: 0,
          className: 'btn-absent',
        },
        presence: {
          text: 'Presente',
          value: 1,
          className: 'btn-presence',
        },
      },
    });

    if (action !== null) {
      const { createAttendanceRequest } = this.props;

      createAttendanceRequest(this.handleGetID(), {
        vacancies: [{ vacancy_id: attendance.attributes.vacancy_id, attendance: action }],
      });
    }
  };

  handleCreateAttendance = (e, type = 1) => {
    e.preventDefault();

    const { attendances, createAttendanceRequest } = this.props;

    const vacancies = attendances.data
      .filter(attendance => !!attendance.attributes.selected)
      .map(attendance => ({
        vacancy_id: attendance.attributes.vacancy_id,
        attendance: type,
      }));

    createAttendanceRequest(this.handleGetID(), { vacancies });
  };

  render() {
    const { breadcrumbs, filters } = this.state;
    const { attendances, dashboard, event } = this.props;

    return (
      <Page className="attendances">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        {!event.loading && event.data.id && (
          <div className="event-detail show-on-print">
            <h2 className="event-detail-title">Lista de Presença - {event.data.attributes.date}</h2>
            <p className="event-detail-name">{event.data.attributes.name}</p>
            <p className="event-detail-local">{event.data.attributes.local.name}</p>
            <p className="event-detail-confirmeds">{dashboard.data.confirmeds} participantes confirmados</p>
          </div>
        )}

        <Page.Title className="hide-on-print">Lista de Clientes Confirmados</Page.Title>
        <h4 className="hide-on-print">Lista de Presença</h4>

        <div className="row box-invite hide-on-print">
          <div className="col-md-2 box">
            <div className="text-box">{dashboard.data.confirmeds}</div>
            <div className="text-description">Confirmados</div>
          </div>

          <div className="col-md-2 box">
            <div className="text-box">{dashboard.data.presents}</div>
            <div className="text-description">Presentes</div>
          </div>

          <div className="col-md-2 box">
            <div className="text-box">{dashboard.data.absents}</div>
            <div className="text-description">Ausentes</div>
          </div>

          <div className="col-md-2 box">
            <div className="text-box">{dashboard.data.not_informed}</div>
            <div className="text-description">Não Marcados</div>
          </div>
        </div>

        <Filters data={filters} onChange={this.handleChangeFilter} />

        <Panel className="panel-list">
          {!attendances.data.length && attendances.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {attendances.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th className="hide-on-print">
                      <Form.Checkbox onChange={this.handleSelectAttendances} />
                    </th>
                    <th>cpf</th>
                    <th>nome</th>
                    <th className="hide-on-print">situação</th>
                    <th className="show-on-print">presença</th>
                    <th className="text-right hide-on-print">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!attendances.data.length && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {attendances.data.map(attendance => (
                    <tr key={attendance.id}>
                      <td className="hide-on-print">
                        <Form.Checkbox
                          checked={attendance.attributes.selected}
                          onChange={() => this.handleSelectAttendance(attendance.id)}
                        />
                      </td>
                      <td>{attendance.attributes.document}</td>
                      <td>{attendance.attributes.name}</td>
                      <td className={`hide-on-print ${attendance.attributes.status.className}`}>{attendance.attributes.status.name}</td>
                      <td className="show-on-print">
                        <span className="checkbox-fake">
                          <span className="checkbox-fake-box" />
                          <span className="checkbox-fake-label">sim</span>
                        </span>

                        <span className="checkbox-fake">
                          <span className="checkbox-fake-box" />
                          <span className="checkbox-fake-label">não</span>
                        </span>
                      </td>
                      <td className="text-right hide-on-print">
                        <a href="/#" className="button-icon" onClick={e => this.handleAskAttendance(e, attendance)}>
                          <span className="glyph glyph-pencil" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="5" />
                  </tr>
                </tfoot>
              </table>

              <div className="hide-on-print">
                <Pagination current={attendances.page} total={attendances.total} {...this.props} />
              </div>

              <div className="buttons-presence hide-on-print">
                <span>Aplicar ao selecionados:</span>
                <a href="/#" className="button-save-presence" onClick={e => this.handleCreateAttendance(e, 1)}>
                  <Icon name="check" prefix="fa" className="presence-icon-save" />
                  Presente
                </a>
                <Link to="/" className="button-cancel-presence" onClick={e => this.handleCreateAttendance(e, 0)}>
                  <Icon name="times" prefix="fa" className="presence-icon-cancel" />
                  Ausente
                </Link>
              </div>

              {/* eslint-disable-next-line */}
              <a href="javascript:window.print();" className="button-list-print hide-on-print">
                <Icon name="print" prefix="fa" className="presence-icon-print" />
                Imprimir lista de clientes confirmados
              </a>

              <Link className="button-back-presence hide-on-print" to={`/events/${this.handleGetID()}/edit`}>
                Voltar
              </Link>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  attendances: {
    ...state.attendances,
    data: AttendancesSelectors.list(state.attendances.data),
  },

  event: {
    ...state.events.detail,
    data: EventSelectors.detail(state.events.detail.data),
  },

  dashboard: state.attendances.dashboard,
});

const mapActions = dispatch => bindActionCreators({ ...AttendancesActions, ...EventsActions }, dispatch);

export default connect(
  mapState,
  mapActions,
)(Attendance);
